// Same pattern as WHATSAPP_ENABLED (src/pages/chat/featureFlags.js). Default OFF.
const runtimeValue = (typeof window !== 'undefined' && window.__RUNTIME_ENV__?.SCORING_ENABLED)
    || process.env.REACT_APP_SCORING_ENABLED;

export const SCORING_ENABLED = runtimeValue === 'true' || runtimeValue === '1';
